module.exports = __webpack_public_path__ + "img/is_travel.4f6f3db1.png";